/**
 * Created by bdickson on 04/12/2015.
 */

namespace TR {

    type ILoggingService = Core.ILoggingService;

    export class TrustpilotService {

        private apiRootUrl: string = 'https://api.trustpilot.com/v1/business-units/' + TRPCONFIG.Domain.TrustPilotId;
        private apiKey: string = TRPCONFIG.Domain.TrustPilotAPIKey;

        constructor (private $http: ng.IHttpService,
                    private loggingService: ILoggingService) {
        }

        getJsonp (url: string) {

            url += (url.indexOf('?') === -1) ? '?' : '&';
            url += 'apikey=' + this.apiKey;

            return this.$http.jsonp(url + '&callback=JSON_CALLBACK', {ignoreErrors: true, cache: true })
                .then(
                    (res:any) => {
                        if (res && angular.isObject(res.data)) {
                            return res.data;
                        }
                        return {};
                    },
                    (err: any) => {
                        this.loggingService
                            .logWarn(`Trustpilot api call failed with following response ${JSON.stringify(err)}`);
                        return {
                            reviews: []
                        };
                    }
                );

        }

        getBusinessUnit () {
            return this.getJsonp(this.apiRootUrl);
        }


    }

    angular.module('TR').service('TrustpilotService', TrustpilotService);

}

